import { useState } from "react"
import { useSnackbar } from "notistack"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { excludeScheduleCommentary } from "../controller/exclude-schedule-commentary"

export function ScheduleCommentaryExcludeMenuItem({ item }) {
    const { enqueueSnackbar } = useSnackbar()
    const [processing, setProcessing] = useState(false)
    const excluded = Boolean(item.excludedFromCycle)
    const icon = excluded ? "mdi:plus-circle-outline" : "mdi:minus-circle-outline"
    const label = excluded ? "Include" : "Exclude"

    return <ContextMenuItem icon={icon} label={label} disabled={processing} onClick={handleToggle} />

    async function handleToggle() {
        setProcessing(true)
        try {
            await excludeScheduleCommentary({ id: item.id, excluded: !excluded })
            enqueueSnackbar(excluded ? "Included in this publish round" : "Excluded from this publish round", {
                variant: "success",
            })
        } catch (error) {
            enqueueSnackbar(error.message || "Failed to update schedule", { variant: "error" })
        } finally {
            setProcessing(false)
        }
    }
}
